import React, { Component } from "react";
import { PageLayout } from "@arise-biodiversity/components";

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    const services = [
      {
        name: "Target List",
        url: "https://use.arise-biodiversity.nl",
      },
      {
        name: "Sampling Tool (ADA)",
        url: "https://ada.arise-biodiversity.nl/",
      },
      {
        name: "Digital Species Identification",
        url: "https://arise-dsi-production-frontend.hosts.naturalis.io",
      },
    ];
    return (
      <PageLayout
        footerContactLink={{
          name: "Contact",
          url: "https://www.arise-biodiversity.nl/contact",
        }}
        footerCookiesLink={{
          name: "Cookies",
          url: "https://www.arise-biodiversity.nl/cookies",
        }}
        footerNavLinks={services}
        footerPrivacyLink={{
          name: "Privacy",
          url: "https://www.arise-biodiversity.nl/privacy",
        }}
        headerLinks={[
          {
            isHeaderLink: true,
            name: "Home",
            url: "/",
          },
          {
            isHeaderLink: false,
            name: "ARISE Biodiversity",
            url: "https://www.arise-biodiversity.nl",
          },
        ]}
        logoLink={{ name: "Home", url: "/" }}>
        {this.props.children}
      </PageLayout>
    );
  }
}
